<template>
    <transition name="fade">
        <div class="modal is-active" v-show="visible">
            <div class="modal-background" @click="destroy"></div>
            <div class="modal-content">
                <div class="popup-dialog">

                    <div class="popup-title">
                        <h1 class="title is-1">{{ formTitle }}</h1>

                        <div class="popup-close" @click.prevent="destroy">
                            <i class="icon">close</i>
                        </div>
                    </div>

                    <g-form action="/void" :form="form" :before="save">
                        <div class="popup-body popup-rows">
                            <div class="columns">
                                <div class="column is-one-third">
                                    <label>{{ $t('reporting.settings.frequency_label') }}</label>
                                </div>
                                <div class="column">
                                    <g-select
                                        name="frequency"
                                        :options="frequencyOptions"
                                    />
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column is-one-third">
                                    <label>{{ $t('reporting.settings.recipient_type') }}</label>
                                </div>
                                <div class="column">
                                    <g-select
                                        name="recipient_type"
                                        :options="recipientTypeOptions"
                                    />
                                </div>
                            </div>

                            <div class="columns" v-if="form.recipient_type === 'custom'">
                                <div class="column is-one-third">
                                    <label>{{ $t('reporting.settings.recipients') }}</label>
                                </div>
                                <div class="column">
                                    <g-input
                                        name="recipients"
                                        :placeholder="$t('reporting.settings.email_placeholder')"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="popup-footer">
                            <a @click.prevent="destroy" href="#" role="button">{{ $t('confirmation_dialog.deny') }}</a>
                            <g-button>{{ $t('reporting.settings.save') }}</g-button>
                        </div>
                    </g-form>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        schedule: {
            type: Object,
            default: null,
        },
        frequencyOptions: {
            type: Array,
            required: true,
        },
        recipientTypeOptions: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            form: new Form({
                frequency: this.schedule ? this.schedule.frequency : 'monthly',
                recipient_type: this.schedule ? this.schedule.recipient_type : 'finance',
                recipients: this.schedule ? (this.schedule.recipients || '') : '',
            }),
        }
    },

    computed: {
        formTitle() {
            return this.schedule
                ? this.$t('reporting.settings.edit_schedule')
                : this.$t('reporting.settings.add_schedule')
        },
    },

    methods: {
        normaliseRecipients(input) {
            return input
                .split(/[\s,;]+/)
                .map(e => e.trim())
                .filter(e => e.length > 0)
                .join(', ')
        },

        save() {
            const recipients = this.form.recipient_type === 'custom'
                ? this.normaliseRecipients(this.form.recipients)
                : ''

            if (this.form.recipient_type === 'custom' && !recipients) {
                this.form.errors.record({
                    recipients: [this.$t('reporting.settings.recipients_required')],
                })
                return false
            }

            this.$emit('saved', {
                frequency: this.form.frequency,
                recipient_type: this.form.recipient_type,
                recipients: recipients,
            })

            this.destroy()
            return false
        },
    },
}
</script>
